import type { MPRShortcut } from '../config';

export const matchesMPRShortcut = (
  shortcut: MPRShortcut,
  code: string,
): boolean => shortcut.code === code || !!shortcut.aliases?.includes(code);

// aria-keyshortcuts wants keys separated by spaces; the help label joins
// alternatives with " / " for people.
export const formatMPRShortcutAriaKeys = (shortcut: MPRShortcut): string =>
  shortcut.label.split(' / ').join(' ');
